import { render } from "./EggAndShark.vue?vue&type=template&id=7dba3af8"
import script from "./EggAndShark.vue?vue&type=script&lang=js"
export * from "./EggAndShark.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__